<template>
  <div class="about-us-area pb-100">
    <div class="container">
      <div class="section-title mw-860">
        <span class="top-title">عزز حياتك اليومية</span>
        <h2>استمتع بكل ما تحب في كل يوم</h2>
      </div>

      <div class="row align-items-center">
        <div class="col-lg-6 col-xxl-7">
          <div class="about-img">
            <img src="@/assets/images/about.jpg" alt="about" />
            <div class="affordable">
              <h4>باقات IPTV منزلية تبدأ من</h4>
              <h2>$ 84.00</h2>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xxl-5">
          <div class="about-content">
            <div class="accordion style-two">
              <div
                class="accordion-item"
                v-for="(item, index) in accordionItems"
                :key="index"
                :class="{ active: activeIndex === index }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button pt-0"
                    type="button"
                    :aria-expanded="activeIndex === index ? 'true' : 'false'"
                    @click="toggleAccordion(index)"
                  >
                    {{ item.title }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndex === index"
                >
                  <div class="accordion-body">
                    <p>
                      {{ item.body }}
                    </p>
                    <ul class="ps-0 list-unstyled about-list">
                      <li
                        v-for="(listItem, i) in item.list"
                        :key="i"
                        class="d-flex align-items-center"
                      >
                        <i class="ti ti-circle-check"></i>
                        <span>{{ listItem }}</span>
                      </li>
                    </ul>

                    <RouterLink to="/pricing-plan" class="btn">
                      <span class="border-style">تسوق باقات الاشتراك</span>
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "DailyLifeFeatures",
  setup() {
    const activeIndex = ref<number>(0);

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    const accordionItems = [
      {
        title: "توفير مع باقات الـ IPTV",
        body: "اجعل تجربة الترفيه المنزلي أكثر سهولة مع سيرفراتنا التي توفر أسرع بث للقنوات الرياضية والترفيهية بجودة فائقة.",
        list: [
          "دعم تشغيل عدة أجهزة في آن واحد",
          "جودة 4K و Full HD في كل مكان",
          "تغطية كاملة للقنوات العربية والعالمية",
        ],
      },
      {
        title: "بث متواصل طوال اليوم",
        body: "لا تضيع أي لحظة من برامجك المفضلة، بفضل تقنيات البث المستقر التي نوفرها لضمان تجربة مشاهدة دون تقطيع.",
        list: [
          "تحديثات مستمرة لمكتبة الأفلام",
          "أسرع استجابة تقنية للبث",
          "دعم فني متاح على مدار الساعة",
        ],
      },
      {
        title: "تجربة ألعاب ومباريات مذهلة",
        body: "استمتع بمتابعة المباريات الكبرى بدقة ووضوح عالي، مع استقرار تام للسيرفرات حتى في أوقات الذروة.",
        list: [
          "بث مباشر بأقل تأخير (Low Latency)",
          "تغطية شاملة لكافة الدوريات الرياضية",
          "واجهة سهلة الاستخدام لجميع أفراد العائلة",
        ],
      },
      {
        title: "شاهد أفلامك ومسلسلاتك المفضلة",
        body: "مكتبة ضخمة تضم أحدث الأفلام والمسلسلات العربية والتركية والأجنبية المترجمة، بضغطة زر واحدة.",
        list: [
          "محتوى متجدد يومياً",
          "جودة صوت وصورة استثنائية",
          "إمكانية الوصول من أي جهاز سمارت",
        ],
      },
    ];

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>